import React, { useRef, useState, useEffect, useCallback } from "react";

const HorizontalScroll = ({ children }) => {
  const containerRef = useRef(null);
  const [scrollLeft, setScrollLeft] = useState(false);
  const [scrollRight, setScrollRight] = useState(false);

  const handleScroll = useCallback(() => {
    if (containerRef.current) {
      const viewableWidth = containerRef.current.getBoundingClientRect().width;
      const scrollableWidth = containerRef.current.scrollWidth;
      const position = containerRef.current?.scrollLeft

      setScrollLeft(position > 0);
      setScrollRight(position + viewableWidth + 10 < scrollableWidth)
    }
  }, [])

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, [handleScroll]);


  return (
    <div css={{ position: "relative", }}>
      <div ref={(node) => containerRef.current = node} css={styles.container} >
        <div css={scrollRight && styles.scrollableRight} />
        {children}
        <div css={scrollLeft && styles.scrollableLeft} />
      </div>
    </div>

  );
}

const styles = {
  container: {
    overflowX: "scroll",
    "::-webkit-scrollbar": {
      display: "none",
    }
  },
  scrollableRight: {
    ":after": {
      content: '""',
      position: "absolute",
      top: 0,
      right: 0,
      background: "linear-gradient(to left, #fff, transparent 100%);",
      width: "15%",
      height: "100%",
      zIndex: 9,
    }
  },
  scrollableLeft: {
    ":before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      background: "linear-gradient(to right, #fff, transparent 100%);",
      width: "15%",
      height: "100%",
      zIndex: 9,
    }
  },

};

export default HorizontalScroll;
